import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
@Component({
  selector: 'app-addestablishtype',
  templateUrl: './addestablishtype.component.html',
  styleUrls: ['./addestablishtype.component.css']
})
export class AddestablishtypeComponent implements OnInit {

  //Mode Values
  isaddmode:boolean=false;
  iseditmode:boolean=false;
  isdeletemode:boolean=false;
  isviewmode:boolean=false;
  
  //Save Validation
  submitted:boolean;
  successfully:boolean;
  
  
  //Edit Get Values
  establishtypeColl:any=[];
  establishtypeid:number=0
  
  //pageColl:any=[];
  
  establishtypeform=new FormGroup({        
    establishtypeid:new FormControl(0),     
    //productgroup:new FormControl('',Validators.required),            
    establishtypename:new FormControl('',Validators.required),   
    inactive:new FormControl(false),     
  });
  
  isloading:boolean=false;
  isprivilage:boolean=false;  
  showProgress:boolean=false;
  formname:String="EstablishType";
  
  constructor(private appService: DhukanDataService,private route: ActivatedRoute,
     public router: Router,private toastr: ToastrService,private loginService:LoginDataService) { 
       this.route.queryParams.subscribe(params => {
        if(params.id!==undefined){
          this.establishtypeid = params.id
        }  
       });
       this.fnServiceChanges();
  }
  
  
  fnServiceChanges(){
    this.loginService.serviceloginChange.subscribe((value) => {
          if(this.loginService.fnCheckUser()){
           
            if(this.fnCheckUserPririvilage()){
              this.isloading=true;
              this.fnOnInitForm();
            }
            else{
              this.fnUserFailedForm();
            }
              
          }
          else{
            this.fnUserFailedForm();
          }
    });
  }
  
  ngOnInit() {
      try{
        if(this.loginService.fnCheckUser()){ 
          if(this.fnCheckUserPririvilage()){       
            this.isloading=true;
            this.fnOnInitForm();
          }
          else{
            this.fnUserFailedForm();
          }
        }
        else{
          this.loginService.fnGetUserRoleList();
        }
                
      }catch(ex){
        this.fnShowErrorMsg(ex);
      }
  }
  
  fnOnInitForm(){
     try{
         this.isaddmode=true;
         this.establishtypeform.reset();
         this.fnInitializeCuisine(); 
  
         if(this.establishtypeid>0){
           this.fngetEstablishType();
         }       
  
     }catch(ex){
       this.fnShowErrorMsg(ex);
     }
  }
  
  
  
  fnCheckUserPririvilage(){
    var _check:boolean=false;
    if (this.establishtypeid>0){
      _check= this.loginService.fnCheckUserRoleAction(this.formname,'ALTER')
    }else{
      _check= this.loginService.fnCheckUserRoleAction(this.formname,'CREATE')
    }
  
    return _check;
  }
  
  fnUserFailedForm(){
    this.isprivilage=true;
  }
  
  
  fnInitializeCuisine(){
     this.establishtypeform.setValue({
       
      establishtypeid:0, 
      establishtypename:'',    
      inactive:false,      
     })
  }
  
  
  
  
  //Get 
  fngetEstablishType() {        
       var data = {
         'establishtypeid':this.establishtypeid,            
       }
       this.appService.getEstablishtype(data)
       .subscribe(
         (res)=>{                  
           this.establishtypeColl=res.json().result;
           var editdata =this.establishtypeColl[0];
           this.fnEditMode(editdata);
       },
       (err)=>{          
         this.toastr.error('Error', err);
       })
  }
  
  
  
  
  //Save Btn Click
  fnSaveBtnClick(){
     try{
       this.submitted=true;
       this.successfully=false;
       //Validate
       if(this.establishtypeform.valid){
           //Check
           var data = {
                 'establishtypeid': this.establishtypeid,                   
                 'establishtypename':this.establishtypeform.get('establishtypename').value,                 
                 'inactive':this.establishtypeform.get('inactive').value,     
                 'createdby': this.loginService.fnGetModUserId(),    
                 'modifiedby':this.loginService.fnGetModUserId(), 
           }
           this.appService.fnCheckEstablishtype(data).subscribe(
             (res)=>{
                 var _checkresult=res.json().result[0].checkfield;
               
                 if(_checkresult==="done"){
                       if (this.establishtypeform.get('establishtypeid').value>0){
                         //Update Department
                         this.fnSetEstablishType(data);
                       }
                       else{
                         //Insert Department
                         this.fnInsertEstablishType(data);
                       }
                 }
                 else{        
                       if(_checkresult==="name"){
                         this.establishtypeform.controls['establishtypename'].setErrors({'notfound': true});
                       }
                 }
           },
           (err)=>{
               this.toastr.error('Error', err);           
           });
        }
     }catch(ex){
       this.fnShowErrorMsg(ex);
     }
  }
  
  //Insert
  fnInsertEstablishType(data){    
   
     this.appService.fnInsertEstablishtype(data).subscribe(
       (res)=>{
       if(res.json().result!=""){
         this.toastr.success('', "The new EstablishType has been added successfully.Insert Successfully");
  
         this.fnInsertActivityLog('INSERT',0,data.establishtypename);
  
         this.fnCloseEstablishType();
       }},
       (err)=>{
         this.toastr.error('Error', err);
       });
  
  }
  
  //Set
  fnSetEstablishType(data){    
  
  this.appService.fnSetEstablishtype(data).subscribe(
   (res)=>{
   if(res.json().result!=""){
       this.toastr.success('', "The EstablishType has been updated successfully.");
  
       this.fnInsertActivityLog('EDIT',this.establishtypeid,data.establishtypename);
  
       this.fnCloseEstablishType();        
   }},
   (err)=>{
     this.toastr.error('Error', err);
   });
  
  }
  
  //Close
  fnCloseEstablishType(){
  try{
    this.router.navigate(['/Establishtype']);
  }catch(ex){
     this.fnShowErrorMsg(ex);
  }
  }
  
  private fnEditMode(deptBO){
  
   this.establishtypeform.setValue({

    establishtypeid:deptBO.establishtypeid,
    establishtypename:deptBO.establishtypename,
        inactive:deptBO.inactive,   
   });
  
  
  this.isaddmode=false;
  this.iseditmode=true;
  this.isdeletemode=false;
  this.isviewmode=false;
  }
  
  
  fnInsertActivityLog(action,refno,desc){
    try{
      var data={
        logtype:action,
        logat:this.formname,
        refnum:refno,
        logdescr:desc,
        logby:this.loginService.fnGetModUserId(),
      }
    
  
      // this.appService.fnInsertActivity(data).subscribe(
      //   (res)=>{
      //   },
      //   (err)=>{
       
      //   });
  
    }catch{
  
    }
  }
  
  
  
  private fnShowProgress(){
    this.showProgress=true;
  }
  private fnHideProgress(){
    this.showProgress=false;
  }
  
  private  fnShowErrorMsg(ex){
  this.toastr.warning('Internal Error', ex);       
  }
  
  
  
  
  
  }
  